if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.endTime = Date.parse(this.dataset.end);
        if (Number.isNaN(this.endTime)) {
          this.hideWrapper();
          return;
        }
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const remaining = this.endTime - Date.now();
        if (remaining <= 0) {
          clearInterval(this.interval);
          this.hideWrapper();
          return;
        }
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        const pad = (n) => String(n).padStart(2, '0');
        this.textContent = days > 0
          ? `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
          : `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      }

      hideWrapper() {
        const wrapper = this.closest('[data-countdown-wrapper]');
        if (wrapper) wrapper.remove();
        else this.remove();
      }
    }
  );
}
